import React, { ReactElement, useState } from "react";
import Confetti from "react-confetti";
import useKeyboardShortcuts from "../../../contexts/KeyboardShortcutContext";
import Confirm from "../../confirm/Confirm";

export default function EasterEgg(): ReactElement {
    const [shouldShow, setShouldShow] = useState<boolean>(false);

    useKeyboardShortcuts(shortcuts => {
        shortcuts.on({
            shortcut: "k+up+up+down+down+left+right+left+right+b+a+s",
            context: "default",
            handler: () => {
                setShouldShow(true);
            },
        });
    });

    return (
        <>
            {shouldShow && (
                <Confetti
                    width={document.body.clientWidth}
                    height={document.body.scrollHeight}
                    initialVelocityY={20}
                    recycle
                />
            )}
            <Confirm
                onHide={() => setShouldShow(false)}
                shouldShow={shouldShow}
            >

                <div className="flex-grow-1 p-3 d-flex flex-column">
                    <img src="https://static.foqal.io/lukas-foqal-all.jpg" alt="Foqal it all" />
                </div>
            </Confirm>

        </>
    );
}
